export const isServer = () => typeof window === 'undefined';

export const isFrame = () => !isServer() && window !== window.parent;
